import {
  clearBookings,
  clearProfile,
  getProfile,
  getProfileActiveTickets,
  getProfileActiveTravelPasses,
  getProfileActiveVouchers,
  getProfileHistoryTickets,
  getProfileHistoryTravelPasses,
  getProfileHistoryVouchers,
} from '@/features/profile/profileActions';
import type {
  CustomerProfileDetailsResponseDTO,
  GetVouchersResponseDTO,
} from '@/types/dto/agent';
import type { BookingSearchResponse } from '@/types/profile';
import { createReducer } from '@reduxjs/toolkit';

export interface ProfileState {
  current: CustomerProfileDetailsResponseDTO | null;
  bookings: {
    tickets: {
      active: BookingSearchResponse | null;
      history: BookingSearchResponse | null;
    };
    travelPasses: {
      active: BookingSearchResponse | null;
      history: BookingSearchResponse | null;
    };
    vouchers: {
      active: GetVouchersResponseDTO | null;
      history: GetVouchersResponseDTO | null;
    };
  };
}

const initialState: ProfileState = {
  current: null,
  bookings: {
    tickets: {
      active: null,
      history: null,
    },
    travelPasses: {
      active: null,
      history: null,
    },
    vouchers: {
      active: null,
      history: null,
    },
  },
};

export const profileReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(getProfile.fulfilled, (state, action) => {
      state.current = action.payload;
    })
    .addCase(clearProfile, (state) => {
      state.current = null;
      state.bookings = initialState.bookings;
    })
    .addCase(clearBookings, (state) => {
      state.bookings = initialState.bookings;
    })
    .addCase(getProfileActiveTickets.fulfilled, (state, action) => {
      const existingData = state.bookings.tickets.active?.data ?? [];
      state.bookings.tickets.active = {
        data: [...existingData, ...action.payload.data],
        totalCount: action.payload.totalCount,
      };
    })
    .addCase(getProfileHistoryTickets.fulfilled, (state, action) => {
      const existingData = state.bookings.tickets.history?.data ?? [];
      state.bookings.tickets.history = {
        data: [...existingData, ...action.payload.data],
        totalCount: action.payload.totalCount,
      };
    })
    .addCase(getProfileActiveTravelPasses.fulfilled, (state, action) => {
      const existingData = state.bookings.travelPasses.active?.data ?? [];
      state.bookings.travelPasses.active = {
        data: [...existingData, ...action.payload.data],
        totalCount: action.payload.totalCount,
      };
    })
    .addCase(getProfileHistoryTravelPasses.fulfilled, (state, action) => {
      const existingData = state.bookings.travelPasses.history?.data ?? [];
      state.bookings.travelPasses.history = {
        data: [...existingData, ...action.payload.data],
        totalCount: action.payload.totalCount,
      };
    })
    .addCase(getProfileActiveVouchers.fulfilled, (state, action) => {
      state.bookings.vouchers.active = action.payload;
    })
    .addCase(getProfileHistoryVouchers.fulfilled, (state, action) => {
      state.bookings.vouchers.history = action.payload;
    });
});
